import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "row"];

  declare readonly inputTarget: HTMLInputElement;
  declare readonly rowTargets: HTMLElement[];

  filter(): void {
    const query = this.inputTarget.value.trim().toLowerCase();

    this.rowTargets.forEach((row) => {
      const name = (row.dataset.name || "").toLowerCase();
      row.hidden = query.length > 0 && !name.includes(query);
    });
  }
}
